import swal from 'sweetalert2'

export const WarningCallback = (text, callback,showCancelButton = false,confirmButtonText="ทราบ") => {
  swal({
    title: "แจ้งให้ทราบ",
    text: text,
    type: 'warning',
    focusConfirm:false,
    confirmButtonText: confirmButtonText,
    confirmButtonColor:"#FFC400",
    cancelButtonText:"ยกเลิก",
    showCancelButton:showCancelButton
  }).then(result => {
    if (result.value) {
      if (callback) {
        callback()
      }
    }
  })
}

export const WarningTitleCallback = (title,text,button_name, callback) => {
  swal({
    title: title,
    text: text,
    type: 'warning',
    focusConfirm:false,
    confirmButtonText: button_name,
    confirmButtonColor:"#FFC400"
  }).then(result => {
    if (result.value) {
      if (callback) {
        callback()
      }
    }
  })
}
